import {
  FormErrorMessage as ChakraFormErrorMessage,
  FormErrorMessageProps,
} from "@ui-kit/form/FormControl/FormControl.web";

// Enforce props when Formik is removed
// import { FormErrorMessageSharedProps } from "./FormErrorMessage.props";

const FormErrorMessage = ({ children, ...props }: FormErrorMessageProps) => {
  return (
    <ChakraFormErrorMessage color="red.600" {...props}>
      {children}
    </ChakraFormErrorMessage>
  );
};

export default FormErrorMessage;
